import { createFileRoute, Navigate } from '@tanstack/react-router';

import { DataSyncTab } from '@apps/web/components/data_sync_tab';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/data-sync')({
    component: DataSyncPage,
});

function DataSyncPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings || !gates.canAccessDataSync) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Data Sync"
            description="Sync the latest data from your scheduling system."
        >
            <DataSyncTab
                key={organizationId}
                organizationId={organizationId}
                variant="embedded"
            />
        </SettingsPageShell>
    );
}
